import type { ModalComponentProps } from "../../../types/modal.types";
import AlertModal from "../alert.modal";

export default function PaymentHistoryListModal({ id, onClose }: ModalComponentProps) {
  return (
    <AlertModal id={id} onClose={onClose} title={"결제 내역"} content={""}>

    </AlertModal>
  );
}